// "use client";

// import { useState } from "react";
// import {
//   Card,
//   CardContent,
//   CardHeader,
//   Typography,
//   TextField,
//   Autocomplete,
//   Button,
//   Box,
//   Container,
//   Grid,
//   Paper,
//   Chip,
//   Divider,
//   Avatar,
//   Stack,
// } from "@mui/material";
// import {
//   Phone,
//   Email,
//   ThumbUp,
//   ThumbDown,
//   LocationOn,
//   Search,
//   Support,
//   ContactPhone,
//   Headset,
// } from "@mui/icons-material";
// import Header from "../components/Header";
// import FixMenu from "../components/FixMenu";
// import Fuse from "fuse.js";

// const contactData = {
//   "Zone 1": {
//     "Greater Noida West": {
//       areas: [
//         "BISRAKH JALALPUR",
//         "KHERA CHAUGANPUR",
//         "TUSYANA",
//         "KHAIRPUR GUJAR",
//         "AIMNABAD",
//         "SECTOR-1 , GREATER NOIDA (West)",
//         "ECOTECH-XII",
//         "TECHZONE - 4",
//         "SECTOR-4 , GREATER NOIDA (West)",
//         "Sector - 10",
//         "TECHZONE-7,  GREATER NOIDA (West)",
//         "SECTOR-20",
//         "ROZA JALALPUR",
//         "SADULLAPUR",
//         "ROZA YAKUBPUR",
//         "HAIVATPUR",
//         "6% Chhapraula",
//         "6% Ithehra",
//         "Sector-16",
//         "Sector-16C",
//         "6% Roza Yakubpur",
//         "6% Patwari",
//         "KNOWLEDGE PARK-5",
//         "Sector-27",
//         "PATWARI",
//         "SECTOR-3 , GREATER NOIDA (West)",
//         "SECTOR-2 , GREATER NOIDA (West)",
//       ],
//       contacts: {
//         "BISRAKH JALALPUR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ankit Rathi - 8750022231",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "KHERA CHAUGANPUR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ankit Rathi - 8750022231",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         TUSYANA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ankit Rathi - 8750022231",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "KHAIRPUR GUJAR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ankit Rathi - 8750022231",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         AIMNABAD: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ankit Rathi - 8750022231",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SECTOR-1 , GREATER NOIDA (West)": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ankit Rathi - 8750022231",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "ECOTECH-XII": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "TECHZONE - 4": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SECTOR-4 , GREATER NOIDA (West)": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "Sector - 10": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "TECHZONE-7,  GREATER NOIDA (West)": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SECTOR-20": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "ROZA JALALPUR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SADULLAPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "ROZA YAKUBPUR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         HAIVATPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "6% Chhapraula": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "6% Ithehra": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "Sector-16": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "Sector-16C": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "6% Roza Yakubpur": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "6% Patwari": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Gaurav - 7835045061",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "KNOWLEDGE PARK-5": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Navin Kumar Gupta - 9266730164",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "Sector-27": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Navin Kumar Gupta - 9266730164",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         PATWARI: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Navin Kumar Gupta - 9266730164",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SECTOR-3 , GREATER NOIDA (West)": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Shubham Kumar Maurya - 9266730182",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SECTOR-2 , GREATER NOIDA (West)": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250961" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Shubham Kumar Maurya - 9266730182",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Kaushal - 8788394546",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Inderpal Singh Lodhi - 8743009896",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//       },
//     },
//     "S-1": {
//       areas: [
//         "SITE C INDUSTRIAL AREA",
//         "SITE C ANSAL HOUSING SOCIETY",
//         "BZP AREA",
//         "CISF CAMP",
//         "DM AWAS COLONY MALAKPUR",
//         "UDYOG KENDRA MAHILA UDYAMI PARK-1",
//         "UDYOG KENDRA-II",
//         "DERIN KHERA CHAUGANPUR",
//         "HABIBPUR",
//         "UDYOG KENDRA-I",
//         "UDYOG KENDRA MAHILA UDYAMI PARK-2",
//         "UDYOG VIHAR",
//         "UDYOG VIHAR EXTENSION",
//         "SARIN FARM",
//         "SITE-B INDUSTRIAL AREA",
//       ],
//       contacts: {
//         "SITE C INDUSTRIAL AREA": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Nikunj Sharma - 8287250611",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SITE C ANSAL HOUSING SOCIETY": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Nikunj Sharma - 8287250611",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "BZP AREA": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pratik Kumar Madhesia - 9266730183/Sonu Paramar -7834807024",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "CISF CAMP": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pratik Kumar Madhesia - 9266730183/Sonu Paramar -7834807024",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "DM AWAS COLONY MALAKPUR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajat Singh - 8700927683",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "UDYOG KENDRA MAHILA UDYAMI PARK-1": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajat Singh - 8700927683",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "UDYOG KENDRA-II": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajat Singh - 8700927683",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "DERIN KHERA CHAUGANPUR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sonu Paramar - 7834807024",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         HABIBPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sonu Paramar - 7834807024",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "UDYOG KENDRA-I": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sudhanshu Singh - 9599554853",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "UDYOG KENDRA MAHILA UDYAMI PARK-2": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sudhanshu Singh - 9599554853",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "UDYOG VIHAR": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Vishal Prajpati - 9266730177",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "UDYOG VIHAR EXTENSION": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Vishal Prajpati - 9266730177",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SARIN FARM": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Vishal Prajpati - 9266730177",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "SITE-B INDUSTRIAL AREA": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Achyuta Prakash - 7982770153",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Dhandhi - 8882192346",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Bhairab Bose - 7834807030",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//       },
//     },
//     "S-2": {
//       areas: [
//         "BAIDPURA",
//         "DEVLA",
//         "TILAPTA KARNWAS",
//         "GULISTANPUR",
//         "MAKORA",
//         "SUNUPURA",
//         "KHERI",
//         "KIRACHPUR",
//         "KHODNA KHURD",
//         "KHODNA KALA",
//         "PALI",
//         "THAPKHERA",
//         "SAINI",
//         "BHOLA RAWAL",
//         "SHEORAJPUR",
//         "KAILASHPUR",
//         "BUDHA ROAD",
//         "BHANOTA",
//         "JANSAMANA",
//         "SURAJPUR",
//         "SUTHYANA",
//         "GURJARPUR",
//         "NALGARHA",
//         "KULESRA",
//         "JALPURA",
//         "HALDAUNI",
//         "MUBARAKPUR",
//         "BEGAMPUR",
//         "MALAKPUR",
//         "LAKHNAWALI",
//         "ALLAVARDIPUR",
//       ],
//       contacts: {
//         BAIDPURA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SURAJPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Himanshu Sharma - 9315407567",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SUTHYANA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Himanshu Tomar - 9315407884",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         JALPURA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Shivam Kumar Singh - 8810317664",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         DEVLA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "TILAPTA KARNWAS": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         GULISTANPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         MAKORA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SUNUPURA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         KHERI: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         KIRACHPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "KHODNA KHURD": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "KHODNA KALA": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         PALI: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         THAPKHERA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SAINI: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "BHOLA RAWAL": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SHEORAJPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         KAILASHPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "BUDHA ROAD": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         BHANOTA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         JANSAMANA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         "TILAPTA KARNWAS": {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ashutosh Pathak - 8878346979",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SURAJPUR: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Himanshu Sharma - 9315407567",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         SUTHYANA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Himanshu Tomar - 9315407884",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//         JALPURA: {
//           level1: {
//             title: "24/7 Call Centre",
//             contact: "0120 6226666, callcenternpcl@rpsg.in",
//           },
//           level2: { title: "24/7 Shift Engineer", contact: "8287250819" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Shivam Kumar Singh - 8810317664",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Siddharth Makhija - 8755492509",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Gaurav Sharma - 9990046407",
//           },
//         },
//       },
//     },
//   },
//   "Zone 2": {
//     "Urban-2": {
//       areas: [
//         "Pi-1 & 2 , Unitech horizon",
//         "Mahalaxmi, jyotikiran,advocate society",
//         "Birondi, bironda",
//         "Pi-1 & 2 , unitech cascade, verve, alestonia, kashiram",
//         "Junpat village & thapkheda ( somertimes), bodaki (sometimes)",
//         "Mu-2 ews , ghodi junpat 6%",
//         "Ultimo society, gaur atulyam, sankalp society",
//         "Omicron-3",
//         "Omicron-3,Mu-2,mu-1 pump only",
//         "Omicron-2 sector",
//         "Sec-36",
//         "Mathurapur and mathurapur 6%",
//         "Parasdeep,sbi bank, jamia,minakshi,informatics,ambey bharti,prasarkunj,Lg and Khusboo apartment society",
//         "Aicher village",
//         "DPS,NFL,HUDCO society",
//         "Sigma-1 & 2",
//         "Sigma-1,2 ,sec-37, 32 pi pumps",
//         "Ekanki enclave, greenwood phase-3,diwani nyayalay, 32 pi sector, gulmohar society",
//         "Sector-37",
//         "ITBP,HPCL,eldico,BSF, parwanath platinum society",
//         "Omicron-1A",
//         "Sigma-3",
//         "Sigma-2",
//         "Sigma-4",
//         "Supertech,eldico society & lal building",
//         "Sigma-4 pump and street light",
//         "Kayampur",
//         "Mu-1",
//         "XU-1, mathurapur,Xu-3, XU-2 pumps",
//         "Xu-2",
//         "XU-1",
//         "Kashiram (XU-2)",
//         "Ghodi bacheda",
//         "Xu-3 A,B & C pocket",
//         "Xu-3 janta flat & raipur bangar 6%",
//         "Builders area pump only",
//         "NTPC,NSG,MITRA,VARUN bevarage,judges, civil service society",
//         "01 nos. transformer near senior citizen society, ring of prakash hospital & senior citizen feeder",
//         "NHPC,HSCC,UPSEB,Airlines society",
//         "SNG plaza, omaxe arcadia,omaxe nri",
//         "senior citizen,Delhi police,alpine,blackgold,greenwood-1  & devine grace society",
//         "Krishna society & ansal golf link-1",
//         "Yatharth hospital, SBI bank,yamuna authority, swagat restaurent, ICICI bank",
//         "Himsagar,lok nirman society, P-4 sector,bhagmalpuram,mahanandan hospital",
//         "CGEWHO",
//         "PHI-3 & PHI-4",
//         "Chi-4",
//         "CHI-3 & SOCIETY, bindal enclave",
//         "CHUHARPUR KHADAR, chuharpur 6% and atta pir",
//         "MOMNATHAL & tubewell",
//         "CHI-4 PUMP",
//         "Chi-5 society",
//         "PHI-4",
//         "Udman, le grand & le regency hotels",
//         "NRI City society & omaxe mall",
//         "Prakash hospital,raksha enclave,engineers park,eldeco,greenwood phase-2, gandharwa society",
//         "P-3 A,B POCKET",
//         "JALVAYU VIHAR & anandashray society",
//         "P-3 C & D pocket",
//         "Swarnagri B,C,D block",
//         "GD goenka,A block, kamla gate RMU O/H, Janta flat",
//         "Aichar",
//         "Bironda",
//         "Kasna",
//         "Ghoribachera",
//         "Sector-36",
//         "Sector 32PI",
//         "MU",
//         "Harpztpur",
//         "Raipur Bangar",
//         "Omicron-1",
//         "PHI-2",
//         "Unitech horizon society",
//         "Mahalaxmi society",
//         "Jyotikiran society",
//         "Advocate society",
//         "Unitech cascade",
//         "Unitech Verve society",
//         "Alestonia apartment",
//         "Kashiram",
//         "Junpat village",
//         "Thapkheda",
//         "Bodaki",
//         "Mu-2 ews",
//         "ghodi junpat 6%",
//         "Birondi",
//         "Bironda",
//         "Ultimo society",
//         "Gaur atulyam society",
//         "Sankalp society",
//         "Omicron-3",
//         "Omicron-2",
//         "Mu-2",
//         "Mu-1 pump",
//         "Omicron-2",
//         "Sector-36",
//         "Mathurapur",
//         "Mathurapur 6%",
//         "Parasdeep",
//         "SBI bank society",
//         "Jamia society",
//         "Minakshi society",
//         "Informatics society",
//         "Ambey bharti society",
//         "Prasarkunj society",
//         "Lg society",
//         "Khusboo apartment",
//         "Aicher village",
//         "DPS society",
//         "HUDCO society",
//         "NFL society",
//         "Sigma-1",
//         "Sigma-2",
//         "Sector-37",
//         "32 PI sector",
//         "Ekanki enclave society",
//         "Greenwood phase-3 society",
//         "Diwani nyayalay society",
//         "Gulmohar society",
//         "ITBP society",
//         "Parwanath platinum society",
//         "Eldeco society",
//         "HPCL society",
//         "Omicron-1A",
//         "Sigma-3",
//         "Sigma-4",
//         // Add these to the areas array (if not present)
//         "PHI-2",
//         "Pocket-P1",
//         "Pocket-P2",
//         "Pocket-P3",
//         "Pocket-P4",
//         "Pocket-P5",
//         "Pocket-P6",
//         "Pocket-P7",
//         "Swarnagri",
//         "Omega-2",
//         "Golf link-1",
//         "Builder link-1",
//         "NTPC society",
//         "NSG society",
//         "MITRA society",
//         "VARUN beverages society",
//         "Judges society",
//         "Civil service society",
//         "NHPC society",
//         "HSCC society",
//         "UPSEB society",
//         "Airlines society",
//         "SNG plaza",
//         "Omaxe arcadia",
//         "Omaxe NRI society",
//         "Senior citizen society",
//         "Delhi police society",
//         "Alpine society",
//         "Blackgold society",
//         "Greenwood society",
//         "Devine grace society",
//         "Krishna society",
//         "Ansal golf link-1",
//       ],
//       contacts: {
//         "Pi-1 & 2 , Unitech horizon": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mahalaxmi, jyotikiran,advocate society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Birondi, bironda": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pi-1 & 2 , unitech cascade, verve, alestonia, kashiram": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Junpat village & thapkheda ( somertimes), bodaki (sometimes)": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mu-2 ews , ghodi junpat 6%": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ultimo society, gaur atulyam, sankalp society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-3,Mu-2,mu-1 pump only": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-2 sector": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sec-36": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mathurapur and mathurapur 6%": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Parasdeep,sbi bank, jamia,minakshi,informatics,ambey bharti,prasarkunj,Lg and Khusboo apartment society":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Pankaj Rai - 8744052916",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         "Aicher village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "DPS,NFL,HUDCO society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-1 & 2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-1,2 ,sec-37, 32 pi pumps": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ekanki enclave, greenwood phase-3,diwani nyayalay, 32 pi sector, gulmohar society":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Pankaj Rai - 8744052916",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         "Sector-37": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "ITBP,HPCL,eldico,BSF, parwanath platinum society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-1A": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Supertech,eldico society & lal building": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-4 pump and street light": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Kayampur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mu-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "XU-1, mathurapur,Xu-3, XU-2 pumps": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Xu-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "XU-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Kashiram (XU-2)": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ghodi bacheda": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Xu-3 A,B & C pocket": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Xu-3 janta flat & raipur bangar 6%": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Builders area pump only": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "NTPC,NSG,MITRA,VARUN bevarage,judges, civil service society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "01 nos. transformer near senior citizen society, ring of prakash hospital & senior citizen feeder":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Devesh Tiwari - 7840050193",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         "NHPC,HSCC,UPSEB,Airlines society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "SNG plaza, omaxe arcadia,omaxe nri": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "senior citizen,Delhi police,alpine,blackgold,greenwood-1  & devine grace society":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Devesh Tiwari - 7840050193",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         "Krishna society & ansal golf link-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Yatharth hospital, SBI bank,yamuna authority, swagat restaurent, ICICI bank":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Devesh Tiwari - 7840050193",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         "Himsagar,lok nirman society, P-4 sector,bhagmalpuram,mahanandan hospital":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Devesh Tiwari - 7840050193",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         CGEWHO: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "PHI-3 & PHI-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Chi-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "CHI-3 & SOCIETY, bindal enclave": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "CHUHARPUR KHADAR, chuharpur 6% and atta pir": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "MOMNATHAL & tubewell": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "CHI-4 PUMP": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Chi-5 society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "PHI-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Udman, le grand & le regency hotels": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "NRI City society & omaxe mall": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Prakash hospital,raksha enclave,engineers park,eldeco,greenwood phase-2, gandharwa society":
//           {
//             level1: { title: "24/7 Call Centre", contact: "01206226666" },
//             level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//             level3: {
//               title: "Area Engineer/Local JE",
//               contact:
//                 "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//             },
//             level4: {
//               title: "Area Incharge",
//               contact: "Devesh Tiwari - 7840050193",
//             },
//             level5: {
//               title: "Division Head",
//               contact: "K A Shashwat- 8130376988",
//             },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//             },
//           },
//         "P-3 A,B POCKET": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "JALVAYU VIHAR & anandashray society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "P-3 C & D pocket": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Swarnagri B,C,D block": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "GD goenka,A block, kamla gate RMU O/H, Janta flat": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Rajesh Agrahari - 9266730168, Kishan Kushawaha - 8527449502",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Aichar: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Bironda: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Kasna: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Ghoribachera: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector-36": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector 32PI": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         MU: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Harpztpur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Raipur Bangar": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "PHI-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Unitech horizon society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mahalaxmi society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Jyotikiran society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Advocate society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Unitech cascade": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Unitech Verve society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Alestonia apartment": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Kashiram: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Junpat village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Thapkheda: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Bodaki: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mu-2 ews": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "ghodi junpat 6%": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Birondi: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ultimo society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Gaur atulyam society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sankalp society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mu-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mu-1 pump": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector-36": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Mathurapur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Mathurapur 6%": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Parasdeep: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "SBI bank society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Jamia society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Minakshi society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Informatics society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ambey bharti society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Prasarkunj society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Lg society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Khusboo apartment": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Aicher village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "DPS society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "HUDCO society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "NFL society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector-37": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "32 PI sector": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ekanki enclave society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Greenwood phase-3 society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Diwani nyayalay society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Gulmohar society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "ITBP society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Parwanath platinum society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Eldeco society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "HPCL society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omicron-1A": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sigma-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact:
//               "Pradeep Singh - 9355651801, Gajendra Singh Rao - 9057515560",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Pankaj Rai - 8744052916",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         // Add these to the contacts object (if not present)
//         "PHI-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P5": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P6": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Pocket-P7": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Swarnagri: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omega-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Golf link-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Builder link-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "NTPC society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "NSG society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "MITRA society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "VARUN beverages society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Judges society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Civil service society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "NHPC society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "HSCC society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "UPSEB society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Airlines society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "SNG plaza": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omaxe arcadia": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Omaxe NRI society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Senior citizen society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Delhi police society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Alpine society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Blackgold society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Greenwood society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Devine grace society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Krishna society": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ansal golf link-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rajesh Agrahari - 9266730168",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Devesh Tiwari - 7840050193",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "K A Shashwat- 8130376988",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//       },
//     },
//     "Urban-1": {
//       areas: [
//         "Alpha-1",
//         "Alpha-2",
//         "Beta-1",
//         "Beta-2",
//         "Delta-1",
//         "Delta-2",
//         "Delta-3",
//         "Gamma-1",
//         "Gamma-2",
//         "KP-4",
//         "Eta-1",
//         "Eta-2",
//         "Authority Pump",
//         "Zeta-1",
//         "Zeta-2",
//         "Rampur Jagir",
//         "Sakipur",
//         "Jaitpur",
//         "Navada",
//         "Boraki ext.",
//         "Makora",
//         "Sector-20",
//         "Boraki",
//         "KP-1",
//         "KP-2",
//         "KP-3",
//         "Jagat Farm",
//         "Tugalpur",
//         "Haldona",
//         "Safipur",
//         "Rohillapur",
//         "Tugalpur Phase-2",
//         "Tugalpur Phase-3",
//         "Amritpuram",
//         "Namoli",
//       ],
//       contacts: {
//         "Alpha-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Alpha-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Beta-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Beta-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Delta-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Delta-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Delta-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Gamma-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Gamma-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "KP-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Eta-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Pramod Kumar - 7011458134",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Eta-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Authority Pump": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Zeta-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Zeta-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Rampur Jagir": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Sakipur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Jaitpur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Navada: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Boraki ext.": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Makora: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector-20": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Boraki: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Sanjay Kumar - 7835045056",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "KP-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "KP-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "KP-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Jagat Farm": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Tugalpur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Haldona: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Safipur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Rohillapur: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Tugalpur Phase-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Tugalpur Phase-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Amritpuram: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         Namoli: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aman Kumar Dubey - 9266730154",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Sanjeev Khare - 7834807034",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Tarun Chauhan - 9911998208",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//       },
//     },
//     Kasna: {
//       areas: [
//         "Ladpura village",
//         "Maicha village",
//         "Patlakhera village",
//         "Rouni village",
//         "Kulipura village",
//         "Bulandkhera village",
//         "Ishepur village",
//         "Talda",
//         "Bagpur village",
//         "Daudpur village",
//         "Bisyach village",
//         "Pipalka Suratpur village",
//         "Atai Muradpur",
//         "Amarpur village",
//         "Dadha village",
//         "Kasna 6% Abadi",
//         "Khanpur 6%",
//         "Ecotech 8",
//         "Motipur village",
//         "Motipur Tubewell",
//         "Gharbara Village",
//         "Murshadpur village",
//         "Jaganpur village",
//         "Nut ki Madhaiya",
//         "Ball Ki Madihiya",
//         "Kasna Village",
//         "Raipur Bangar village",
//         "Dabra village",
//         "Rampur Manjara",
//         "Aalamkhani",
//         "SirjhaKhani",
//         "Fathekhani",
//         "Mohamdkhani",
//         "Bilaspur",
//         "Girdharpur",
//         "Chirsi",
//         "Kherli Hafizpur",
//         "Azampur Garhi",
//         "Astoli",
//         "Janipura",
//         "Panchytan",
//         "Jhalda",
//         "Junedpur",
//         "Roshanpur",
//         "Kanarsa",
//         "Kanarsi",
//         "Samspur",
//         "Nanwa Ka Rajpur",
//         "Chachula",
//         "Hatewa",
//         "Nawada",
//         "PTW",
//         "Pipal ka surtapur",
//         "Khanpur",
//         "Sirsa",
//         "Ghanghola",
//         "Aminabad urf niyana",
//         "Salempur Gujjar",
//         "Imaliyaka village",
//         "Povari",
//         "Dadupur Village",
//         "Rithori",
//         "Ajaypur",
//         "Fathepur Rampur",
//         "Luksar village",
//         "Luksar 6%",
//         "Ecotech-1 Extension-1",
//         "Ecotech-1 Extension",
//         "Ecotech extension -1",
//         "EPIP",
//         "Site-5",
//         "Ecotech-6",
//         "Luksar jail",
//         "DIMIC",
//         "Galgotias university",
//         "Dhanshree foods",
//         "Supertech",
//         "Coforge",
//         "AMR Mall",
//         "Sector 31",
//         "Site-4",
//         "Sector-41",
//         "Techzone-2",
//         "Sector-31",
//         "Ecotech -11",
//         "Techzone-3",
//         "Ecotech-10"
//       ],
//       contacts: {
//         "Ladpura village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Maicha village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Patlakhera village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Rouni village, Kulipura village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Bulandkhera village, Ishepur, Talda village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Dalegarh, bagpur, Daudpur, Bisyach, Pipalka Suratpur village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Atai Muradpur, Amarpur village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Aayush Maurya - 7011658455",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Dadha village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Kasna 6% Abadi, Khanpur 6%, Ecotech 8": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Motipur village , Motipur Tubewell": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Gharbara Village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Murshadpur village , Jaganpur village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Nut ki Madhaiya,Ball Ki Madihiya,Kasna Village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Dabra village, Raipur Bangar village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Ayush Gupta - 9355651819",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Rampur Manjara, Aalamkhani, SirjhaKhani,Fathekhani, Mohamdkhani, Bilaspur":
//           {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//               contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//               contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//             level6: {
//               title: "Zonal Head",
//               contact: "Bhupesh Yadav- 8750048486",
//         },
//           },
//         "Girdharpur,Chirsi": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Bhupesh Yadav- 8750048486",
//         },
//         },
//         "Kherli Hafizpur, Azampur Garhi,Astoli,Janipura": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Bhupesh Yadav- 8750048486",
//         },
//         },
//         Panchytan: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Bhupesh Yadav- 8750048486",
//         },
//         },
//         "Jhalda , Junedpur,Roshanpur": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Bhupesh Yadav- 8750048486",
//         },
//         },
//         "Kanarsa, Kanarsi,Samspur,Nanwa Ka Rajpur,Chachula": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Bhupesh Yadav- 8750048486",
//         },
//         },
//         "Hatewa,Nawada,PTW ,Pipal ka surtapur": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Deepak Prajapati - 9891701297",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: {
//             title: "Zonal Head",
//             contact: "Bhupesh Yadav- 8750048486",
//         },
//         },
//         "Khanpur , Sirsa": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ghanghola,Aminabad urf niyana,Salempur Gujjar": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Imaliyaka village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Povari, Dadupur Village": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Rithori, Ajaypur, Fathepur Rampur": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Luksar village, Luksar 6%": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Mukesh kumar Vishwakarma - 9355651826",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech-1 Extension-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },

//         "Ecotech-1 Extension-1, Ecotech-1 Extension": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech-1 Extension": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech extension -1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         EPIP: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "EPIP, Site-5": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Santosh Kumar Yadav - 9871511778",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech extension -1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Dipu Rai - 9355651805",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Dipu Rai  - 9355651805",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Site-5 ,Ecotech-6": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Dipu Rai - 9355651805",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Dipu Rai  - 9355651805",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech-6": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Dipu Rai - 9355651805",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Dipu Rai  - 9355651805",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Site-5": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Dipu Rai - 9355651805",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Dipu Rai  - 9355651805",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Site-5, EPIP": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Dipu Rai - 9355651805",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Dipu Rai  - 9355651805",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Luksar jail": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Dipu Rai - 9355651805",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Dipu Rai  - 9355651805",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         DIMIC: {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Galgotias,Supertech,Dhanshree": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Coforge , AMR Mall, Techzone-2": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector 31, Site-4 ,Sector-41": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Sector-31": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech -11": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech extension -1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Site-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech-1 Extension-1": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Site-4": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech-1 Extension-1 , Techzone-3": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Ecotech-10": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//         "Rahul Sharma - 9266730142": {
//           level1: { title: "24/7 Call Centre", contact: "01206226666" },
//           level2: { title: "24/7 Shift Engineer", contact: "8287251907" },
//           level3: {
//             title: "Area Engineer/Local JE",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level4: {
//             title: "Area Incharge",
//             contact: "Rahul Sharma - 9266730142",
//           },
//           level5: {
//             title: "Division Head",
//             contact: "Awadhesh Pradeep Fulzade - 8744052911",
//           },
//           level6: { title: "Zonal Head", contact: "Bhupesh Yadav- 8750048486" },
//         },
//       },
//     },
//   },
// };

// export default function ContactUsPage() {
//   const [selectedArea, setSelectedArea] = useState(null);
//   const [selectedZone, setSelectedZone] = useState("");
//   const [selectedDivision, setSelectedDivision] = useState("");
//   const [currentLevel, setCurrentLevel] = useState(1);
//   const [contactInfo, setContactInfo] = useState(null);

//   const getAllAreas = () => {
//     const areas = [];
//     Object.keys(contactData).forEach((zone) => {
//       Object.keys(contactData[zone]).forEach((division) => {
//         contactData[zone][division].areas.forEach((area) => {
//           areas.push({
//             label: area,
//             zone,
//             division,
//           });
//         });
//       });
//     });
//     return areas.sort((a, b) => a.label.localeCompare(b.label));
//   };

//   const handleAreaChange = (event, newValue) => {
//     if (!newValue) return;
//     setSelectedArea(newValue);
//     setCurrentLevel(1);
//     setSelectedZone(newValue.zone);
//     setSelectedDivision(newValue.division);

//     const contacts =
//       contactData[newValue.zone][newValue.division].contacts[newValue.label];
//     if (contacts) {
//       setContactInfo(contacts);
//     } else {
//       const defaultContacts = Object.values(
//         contactData[newValue.zone][newValue.division].contacts
//       )[0];
//       setContactInfo(defaultContacts);
//     }
//   };

//   const handleSatisfactionClick = (satisfied) => {
//     if (!satisfied && currentLevel < 6) {
//       setCurrentLevel(currentLevel + 1);
//     } else if (satisfied) {
//       alert("Thank you for your feedback! We're glad we could help.");
//     } else {
//       alert(
//         "We apologize for the inconvenience. This is our highest level of support."
//       );
//     }
//   };
//   const formatContact = (contact) => {
//     if (!contact) return [];
//     let contacts = [];
//     if (Array.isArray(contact)) {
//       contacts = contact;
//     } else {
//       contacts = contact
//         .split(/\s*\/|,\s*/)
//         .map((c) => c.trim())
//         .filter(Boolean);
//     }
//     return contacts.map((c) => {
//       if (c.includes("@")) {
//         return { type: "email", value: c };
//       } else if (c.match(/\d/)) {
//         return { type: "phone", value: c };
//       }
//       return { type: "text", value: c };
//     });
//   };

//   const getEscalationSteps = () => {
//     if (!contactInfo) return [];
//     const stepKeys = ["level2", "level3", "level4", "level5", "level6"];
//     return stepKeys
//       .slice(0, currentLevel)
//       .map((key, idx) => {
//         const level = contactInfo[key];
//         if (!level) return null;
//         return { ...level, level: idx + 1 };
//       })
//       .filter(Boolean);
//   };

//   return (
//     <div id="bodyaddid">
//       <Header />
//       <FixMenu />
//       <section className="main_sectiods" style={{ marginTop: "60px" }}>
//         <div className="container main_bdy" style={{ maxWidth: "1283px" }}>
//           <Box sx={{ minHeight: "100vh", background: "#f8fafc", py: 2 }}>
//             <Container maxWidth="lg">
//               <Box sx={{ textAlign: "center", mb: 3 }}>
//                 {/* <Typography
//                   variant="h4"
//                   sx={{
//                     fontWeight: 700,
//                     color: "#1e293b",
//                     mb: 1,
//                     fontSize: { xs: "1.8rem", md: "2.2rem" },
//                   }}
//                 >
//                   Contact Us
//                 </Typography> */}
//                 {/* <Typography variant="subtitle1" sx={{ color: "#64748b", fontSize: "1rem" }}>
//                   Get in touch with our support team for assistance
//                 </Typography> */}
//               </Box>
//               <Card
//                 sx={{
//                   mb: 2,
//                   borderRadius: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   border: "1px solid #e2e8f0",
//                 }}
//               >
//                 <CardHeader
//                   sx={{
//                     background:
//                       "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
//                     color: "white",
//                     py: 2,
//                   }}
//                   avatar={<LocationOn sx={{ fontSize: 28 }} />}
//                   title={
//                     <Typography
//                       variant="h6"
//                       sx={{ fontWeight: 600, fontSize: "1.1rem" }}
//                     >
//                       Select Your Location
//                     </Typography>
//                   }
//                 />
//                 <CardContent sx={{ p: 2.5 }}>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} md={4}>
//                       <Autocomplete
//                         options={getAllAreas()}
//                         getOptionLabel={(option) => option.label}
//                         value={selectedArea}
//                         onChange={handleAreaChange}
//                         size="small"
//                         renderInput={(params) => (
//                           <TextField
//                             {...params}
//                             label="Search Your Area"
//                             placeholder="Type to search..."
//                             variant="outlined"
//                             fullWidth
//                             style={{ width: "270px" }}
//                             InputProps={{
//                               ...params.InputProps,
//                               startAdornment: (
//                                 <Search
//                                   sx={{ color: "#64748b", mr: 1, fontSize: 20 }}
//                                 />
//                               ),
//                             }}
//                           />
//                         )}
//                         renderOption={(props, option) => (
//                           <Box component="li" {...props} sx={{ py: 1 }}>
//                             <Box>
//                               <Typography
//                                 variant="body2"
//                                 sx={{ fontWeight: 600, fontSize: "0.9rem" }}
//                               >
//                                 {option.label}
//                               </Typography>
//                               <Typography
//                                 variant="caption"
//                                 color="text.secondary"
//                                 sx={{ fontSize: "0.75rem" }}
//                               >
//                                 {option.zone} → {option.division}
//                               </Typography>
//                             </Box>
//                           </Box>
//                         )}
//                         filterOptions={(options, { inputValue }) => {
//                           if (!inputValue) return [];
//                           const fuse = new Fuse(options, {
//                             keys: ["label", "zone", "division"],
//                             threshold: 0.4,
//                             ignoreLocation: true,
//                             minMatchCharLength: 1,
//                           });
//                           const results = fuse.search(inputValue);
//                           return results.map((result) => result.item);
//                         }}
//                       />
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                       <TextField
//                         label="Zone"
//                         value={selectedZone || "Auto-selected"}
//                         fullWidth
//                         disabled
//                         style={{ width: "270px" }}
//                         size="small"
//                         variant="outlined"
//                         sx={{
//                           "& .MuiInputBase-input.Mui-disabled": {
//                             WebkitTextFillColor: selectedZone
//                               ? "#1e293b"
//                               : "#64748b",
//                           },
//                         }}
//                       />
//                     </Grid>
//                     <Grid item xs={12} md={4}>
//                       <TextField
//                         label="Division"
//                         value={selectedDivision || "Auto-selected"}
//                         fullWidth
//                         disabled
//                         style={{ width: "270px" }}
//                         size="small"
//                         variant="outlined"
//                         sx={{
//                           "& .MuiInputBase-input.Mui-disabled": {
//                             WebkitTextFillColor: selectedDivision
//                               ? "#1e293b"
//                               : "#64748b",
//                           },
//                         }}
//                       />
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>

//               {/* Contact Information */}
//               {contactInfo && (
//                 <Card
//                   sx={{
//                     borderRadius: 3,
//                     boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                     border: "1px solid #e2e8f0",
//                   }}
//                 >
//                   <CardHeader
//                     sx={{
//                       background:
//                         "linear-gradient(135deg, #059669 0%, #047857 100%)",
//                       color: "white",
//                       py: 2,
//                     }}
//                     avatar={<ContactPhone sx={{ fontSize: 28 }} />}
//                     title={
//                       <Typography
//                         variant="h6"
//                         sx={{ fontWeight: 600, fontSize: "1.1rem" }}
//                       >
//                         Support Contact Information
//                       </Typography>
//                     }
//                   />
//                   <CardContent sx={{ p: 2.5 }}>
//                     <Paper
//                       elevation={2}
//                       sx={{
//                         p: 2,
//                         mb: 2,
//                         borderRadius: 2,
//                         background:
//                           "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
//                         border: "1px solid #3b82f6",
//                       }}
//                     >
//                       <Stack direction="row" spacing={2} alignItems="center">
//                         <Avatar
//                           sx={{ bgcolor: "#3b82f6", width: 40, height: 40 }}
//                         >
//                           <Headset />
//                         </Avatar>
//                         <Box sx={{ flex: 1 }}>
//                           <Typography
//                             variant="subtitle2"
//                             sx={{ fontWeight: 700, color: "#1e40af", mb: 0.5 }}
//                           >
//                             24/7 Call Centre (Help Desk)
//                           </Typography>
//                           <Stack direction="row" spacing={1} flexWrap="wrap">
//                             {formatContact(contactInfo.level1?.contact).map(
//                               (contactObj, idx) => (
//                                 <Chip
//                                   key={idx}
//                                   icon={
//                                     contactObj.type === "email" ? (
//                                       <Email sx={{ fontSize: 16 }} />
//                                     ) : (
//                                       <Phone sx={{ fontSize: 16 }} />
//                                     )
//                                   }
//                                   label={contactObj.value}
//                                   color={
//                                     contactObj.type === "email"
//                                       ? "info"
//                                       : "primary"
//                                   }
//                                   size="small"
//                                   sx={{ fontSize: "0.75rem", height: 24 }}
//                                 />
//                               )
//                             )}
//                           </Stack>
//                         </Box>
//                       </Stack>
//                     </Paper>
//                     <Box sx={{ position: "relative", pl: 2 }}>
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           top: 20,
//                           left: 30,
//                           bottom: 0,
//                           width: 2,
//                           bgcolor: "#e2e8f0",
//                           zIndex: 0,
//                         }}
//                       />

//                       {getEscalationSteps().map((level, idx) => (
//                         <Box
//                           key={level.level}
//                           sx={{
//                             display: "flex",
//                             alignItems: "flex-start",
//                             position: "relative",
//                             mb: 2,
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               bgcolor:
//                                 level.level === currentLevel
//                                   ? "#059669"
//                                   : "#94a3b8",
//                               color: "white",
//                               width: 32,
//                               height: 32,
//                               fontSize: 14,
//                               fontWeight: 700,
//                               zIndex: 1,
//                             }}
//                           >
//                             {level.level}
//                           </Avatar>
//                           <Paper
//                             elevation={level.level === currentLevel ? 3 : 1}
//                             sx={{
//                               p: 2,
//                               ml: 2,
//                               flex: 1,
//                               borderRadius: 2,
//                               background:
//                                 level.level === currentLevel
//                                   ? "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)"
//                                   : "#f8fafc",
//                               border:
//                                 level.level === currentLevel
//                                   ? "1px solid #059669"
//                                   : "1px solid #e2e8f0",
//                             }}
//                           >
//                             <Stack
//                               direction="row"
//                               spacing={1}
//                               alignItems="center"
//                               sx={{ mb: 1 }}
//                             >
//                               <Typography
//                                 variant="subtitle2"
//                                 sx={{ fontWeight: 700, fontSize: "0.9rem" }}
//                               >
//                                 {level.title}
//                               </Typography>
//                               {level.level === currentLevel && (
//                                 <Chip
//                                   label="Current"
//                                   color="success"
//                                   size="small"
//                                   sx={{ fontSize: "0.7rem", height: 20 }}
//                                 />
//                               )}
//                               <Chip
//                                 label={`Level ${level.level}`}
//                                 color="default"
//                                 size="small"
//                                 sx={{ fontSize: "0.7rem", height: 20 }}
//                               />
//                             </Stack>
//                             <Stack direction="row" spacing={1} flexWrap="wrap">
//                               {formatContact(level.contact).map(
//                                 (contactObj, idx) => (
//                                   <Chip
//                                     key={idx}
//                                     icon={
//                                       contactObj.type === "email" ? (
//                                         <Email sx={{ fontSize: 14 }} />
//                                       ) : (
//                                         <Phone sx={{ fontSize: 14 }} />
//                                       )
//                                     }
//                                     label={contactObj.value}
//                                     color={
//                                       contactObj.type === "email"
//                                         ? "info"
//                                         : "primary"
//                                     }
//                                     size="small"
//                                     sx={{ fontSize: "0.75rem", height: 24 }}
//                                   />
//                                 )
//                               )}
//                             </Stack>
//                           </Paper>
//                         </Box>
//                       ))}
//                     </Box>

//                     {/* Selected Location Info
//                     <Paper sx={{ p: 2, mb: 2, bgcolor: "#f1f5f9", borderRadius: 2 }}>
//                       <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: "#334155" }}>
//                         Selected Location:
//                       </Typography>
//                       <Stack direction="row" spacing={1} flexWrap="wrap">
//                         <Chip label={`Area: ${selectedArea?.label}`} color="primary" variant="outlined" size="small" />
//                         <Chip label={`Zone: ${selectedZone}`} color="secondary" variant="outlined" size="small" />
//                         <Chip label={`Division: ${selectedDivision}`} color="success" variant="outlined" size="small" />
//                       </Stack>
//                     </Paper> */}

//                     <Divider sx={{ my: 2 }} />

//                     {/* Satisfaction Feedback */}
//                     <Paper
//                       sx={{
//                         p: 2,
//                         textAlign: "center",
//                         bgcolor: "#ffffff",
//                         borderRadius: 2,
//                         border: "1px solid #e2e8f0",
//                       }}
//                     >
//                       <Typography
//                         variant="subtitle1"
//                         sx={{ fontWeight: 600, mb: 2, color: "#1e293b" }}
//                       >
//                         Are we able to resolve your issue?
//                       </Typography>
//                       <Stack
//                         direction="row"
//                         spacing={2}
//                         justifyContent="center"
//                       >
//                         <Button
//                           variant="contained"
//                           color="success"
//                           size="medium"
//                           startIcon={<ThumbUp />}
//                           onClick={() => handleSatisfactionClick(true)}
//                           sx={{
//                             px: 3,
//                             py: 1,
//                             fontSize: "0.9rem",
//                             fontWeight: 600,
//                             borderRadius: 2,
//                             textTransform: "none",
//                           }}
//                         >
//                           Satisfied
//                         </Button>
//                         {currentLevel < 5 && (
//                           <Button
//                             variant="contained"
//                             color="error"
//                             size="medium"
//                             startIcon={<ThumbDown />}
//                             onClick={() => handleSatisfactionClick(false)}
//                             sx={{
//                               px: 3,
//                               py: 1,
//                               fontSize: "0.9rem",
//                               fontWeight: 600,
//                               borderRadius: 2,
//                               textTransform: "none",
//                             }}
//                           >
//                             Not Satisfied
//                           </Button>
//                         )}
//                       </Stack>
//                       {currentLevel < 5 && (
//                         <Typography
//                           variant="caption"
//                           sx={{ mt: 1, color: "#64748b", display: "block" }}
//                         >
//                           Click "Escalate" to reach the next level of support
//                         </Typography>
//                       )}
//                     </Paper>
//                   </CardContent>
//                 </Card>
//               )}

//               {/* Instructions */}
//               {!selectedArea && (
//                 <Card
//                   sx={{
//                     mt: 2,
//                     borderRadius: 3,
//                     boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                     border: "1px solid #e2e8f0",
//                   }}
//                 >
//                   <CardContent sx={{ p: 3, textAlign: "center" }}>
//                     <Support sx={{ fontSize: 48, color: "#3b82f6", mb: 2 }} />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: 600, color: "#1e293b", mb: 2 }}
//                     >
//                       How to Get Support
//                     </Typography>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} sm={6} md={3}>
//                         <Paper
//                           sx={{
//                             p: 2,
//                             bgcolor: "#3b82f6",
//                             color: "#fff",
//                             borderRadius: 2,
//                             height: "100%",
//                             width: "190px",
//                           }}
//                         >
//                           <Typography
//                             variant="h6"
//                             sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
//                           >
//                             Step 1
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ fontSize: "0.85rem" }}
//                           >
//                             Select your locality area
//                           </Typography>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={3}>
//                         <Paper
//                           sx={{
//                             p: 2,
//                             bgcolor: "#059669",
//                             color: "#fff",
//                             borderRadius: 2,
//                             height: "100%",
//                             width: "190px",
//                           }}
//                         >
//                           <Typography
//                             variant="h6"
//                             sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
//                           >
//                             Step 2
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ fontSize: "0.85rem" }}
//                           >
//                             Zone & Division auto-selected
//                           </Typography>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={3}>
//                         <Paper
//                           sx={{
//                             p: 2,
//                             bgcolor: "#dc2626",
//                             color: "#fff",
//                             borderRadius: 2,
//                             height: "100%",
//                             width: "190px",
//                           }}
//                         >
//                           <Typography
//                             variant="h6"
//                             sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
//                           >
//                             Step 3
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ fontSize: "0.85rem" }}
//                           >
//                             Contact support team
//                           </Typography>
//                         </Paper>
//                       </Grid>
//                       <Grid item xs={12} sm={6} md={3}>
//                         <Paper
//                           sx={{
//                             p: 2,
//                             bgcolor: "#7c3aed",
//                             color: "#fff",
//                             borderRadius: 2,
//                             height: "100%",
//                             width: "190px",
//                           }}
//                         >
//                           <Typography
//                             variant="h6"
//                             sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
//                           >
//                             Step 4
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             sx={{ fontSize: "0.85rem" }}
//                           >
//                             Escalate if needed
//                           </Typography>
//                         </Paper>
//                       </Grid>
//                     </Grid>
//                   </CardContent>
//                 </Card>
//               )}
//             </Container>
//           </Box>
//         </div>
//       </section>
//     </div>
//   );
// }
"use client";

import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  TextField,
  Autocomplete,
  Button,
  Box,
  Container,
  Grid,
  Paper,
  Chip,
  Divider,
  Avatar,
  Stack,
  Alert,
  Snackbar,
} from "@mui/material";
import {
  Phone,
  Email,
  ThumbUp,
  ThumbDown,
  LocationOn,
  Search,
  Support,
  ContactPhone,
  Headset,
} from "@mui/icons-material";
import Header from "../components/Header";
import FixMenu from "../components/FixMenu";
import Fuse from "fuse.js";
import apiEndpoints from "../utils/apiEndpoints";
import axios from "axios";

export default function ContactUsPage() {
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedZone, setSelectedZone] = useState(""); 
  const [selectedDivision, setSelectedDivision] = useState(""); 
  const [currentLevel, setCurrentLevel] = useState(1);
  const [contactInfo, setContactInfo] = useState(null); 
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [consumerNo, setConsumerNo] = useState("");
  const [feedback, setFeedback] = useState("");
  const [feedbackLoading, setFeedbackLoading] = useState(false);
  const [feedbackSuccess, setFeedbackSuccess] = useState(false);
  const [feedbackError, setFeedbackError] = useState("");


  const fetchAllAreas = async () => {
    try {
      const token = sessionStorage.getItem("access_token");
      const response = await axios.get(apiEndpoints.getAllAreas, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 200 && response.data.geographical_area) {
        const areaList = response.data.geographical_area
          .split(",")
          .map((area) => area.trim())
          .filter(Boolean)
          .map((area) => ({ label: area }));
        setAreas(areaList);
      }
    } catch (error) {
      console.error("Error fetching streets/localities:", error);
    }
  };

  useEffect(() => {
    fetchAllAreas();
  }, []);

  const getAllAreas = () => areas;
  const handleAreaChange = async (event, newValue) => {
    if (!newValue) return;
    setSelectedArea(newValue);
    setCurrentLevel(1);
    setSelectedZone("");
    setSelectedDivision(""); 
    setContactInfo(null); 
    try {
      const token = sessionStorage.getItem("access_token");
      const response = await axios.get(
        apiEndpoints.getAreaWiseInformation,
        {
          params: { SEARCH_AREA: newValue.label },
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200 && response.data) {
        setSelectedZone(response.data.zone || "");
        setSelectedDivision(response.data.area || "");
        setContactInfo({
          level1: {
            title: "Call Centre (Help Desk)",
            contact: response.data.CALL_CENTRE_1ST_LEVEL || "",
          },
          level2: {
            title: "Shift Engineer",
            contact: response.data.SHIFT_ENGINEER_2ND_LEVEL || "",
          },
          level3: {
            title: "Area Engineer / Local JE",
            contact: response.data.AREA_ENGINEER_LOCAL_JE_3RD || "",
          },
          level4: {
            title: "Area Incharge",
            contact: response.data.AREA_INCHARGE_4TH_LEVEL || "",
          },
          level5: {
            title: "Division Head",
            contact: response.data.DIVISION_HEAD_5TH_LEVEL || "",
          },
          level6: {
            title: "Zonal Head",
            contact: response.data.ZONAL_HEAD_6TH_LEVEL || "",
          },
        });
        console.log("Area-wise info:", response.data);
      }
    } catch (error) {
      console.error("Error fetching area-wise info:", error);
    }
  };

  const handleSatisfactionClick = (satisfied) => {
    if (!satisfied && currentLevel < 6) {
      setCurrentLevel(currentLevel + 1);
      if ([2, 3, 4, 5].includes(currentLevel + 1)) {
        setShowFeedbackForm(true);
      }
    } else if (satisfied) {
      alert("Thank you for your feedback! We're glad we could help.");
    } else {
      alert(
        "We apologize for the inconvenience. This is our highest level of support."
      );
    }
  };
  const formatContact = (contact) => {
    if (!contact) return [];
    let contacts = [];
    if (Array.isArray(contact)) {
      contacts = contact;
    } else {
      contacts = contact
        .split(/\s*\/|,\s*/)
        .map((c) => c.trim())
        .filter(Boolean);
    }
    return contacts.map((c) => {
      if (c.includes("@")) {
        return { type: "email", value: c };
      } else if (c.match(/\d/)) {
        return { type: "phone", value: c };
      }
      return { type: "text", value: c };
    });
  };

  const getEscalationSteps = () => {
    if (!contactInfo) return [];
    const stepKeys = ["level2", "level3", "level4", "level5", "level6"];
    return stepKeys
      .slice(0, currentLevel)
      .map((key, idx) => {
        const level = contactInfo[key];
        if (!level) return null;
        return { ...level, level: idx + 1 };
      })
      .filter(Boolean);
  };

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();
    setFeedbackLoading(true);
    setFeedbackError("");
    setFeedbackSuccess(false);
    try {
      const token = sessionStorage.getItem("access_token");
      const response = await axios.post(
        apiEndpoints.addFeedback,
        {
          CONSUMER_NO: consumerNo,
          FEEDBACK: feedback,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        setFeedbackSuccess(true);
        setConsumerNo("");
        setFeedback("");
        setShowFeedbackForm(false);
      } else {
        setFeedbackError("Failed to submit feedback. Please try again.");
      }
    } catch (error) {
      setFeedbackError("Failed to submit feedback. Please try again.");
    } finally {
      setFeedbackLoading(false);
    }
  };
  
  return (
    // <div id="bodyaddid">
    <>
        {/* <Header />
        <FixMenu /> */}
      {/* <section className="main_sectiods" style={{ marginTop: "60px" }}> */}
        {/* <div className="container main_bdy" style={{ maxWidth: "1283px" }}> */}
          <Box sx={{ minHeight: "100vh", background: "#f8fafc", py: 2 }}>
            <Container maxWidth="lg">
              <Card
                sx={{
                  mb: 2,
                  borderRadius: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  border: "1px solid #e2e8f0",
                }}
              >
                <CardHeader
                  sx={{
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
                    color: "white",
                    py: 2,
                  }}
                  avatar={<LocationOn sx={{ fontSize: 28 }} />}
                  title={
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 600, fontSize: "16px" }}
                    >
                      Select Your Location
                    </Typography>
                  }
                />
                <CardContent sx={{ p: 2.5 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        options={getAllAreas()}
                        getOptionLabel={(option) => option.label}
                        value={selectedArea}
                        onChange={handleAreaChange}
                        size="small"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Search Your Area"
                            placeholder="Type to search..."
                            variant="outlined"
                            fullWidth
                            style={{ width: "270px", }}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <Search
                                  sx={{ color: "#64748b", mr: 1, fontSize: 20 }}
                                />
                              ),
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <Box component="li" {...props} sx={{ py: 1 }}>
                            <Box>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 600, fontSize: "0.9rem" }}
                              >
                                {option.label}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ fontSize: "0.75rem" }}
                              >
                                {option.zone} → {option.division}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                        filterOptions={(options, { inputValue }) => {
                          if (!inputValue) return [];
                          const fuse = new Fuse(options, {
                            keys: ["label", "zone", "division"],
                            threshold: 0.4,
                            ignoreLocation: true,
                            minMatchCharLength: 1,
                          });
                          const results = fuse.search(inputValue);
                          return results.map((result) => result.item);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        label="Zone"
                        value={selectedZone || "Auto-selected"}
                        fullWidth
                        disabled
                        style={{ width: "270px" }}
                        size="small"
                        variant="outlined"
                        sx={{
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: selectedZone
                              ? "#1e293b"
                              : "#64748b",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <TextField
                        label="Division"
                        value={selectedDivision || "Auto-selected"}
                        fullWidth
                        disabled
                        style={{ width: "270px" }}
                        size="small"
                        variant="outlined"
                        sx={{
                          "& .MuiInputBase-input.Mui-disabled": {
                            WebkitTextFillColor: selectedDivision
                              ? "#1e293b"
                              : "#64748b",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {contactInfo && (
                <Card
                  sx={{
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <CardHeader
                    sx={{
                      background:
                        "linear-gradient(135deg, #059669 0%, #047857 100%)",
                      color: "white",
                      py: 2,
                    }}
                    avatar={<ContactPhone sx={{ fontSize: 28 }} />}
                    title={
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 600, fontSize: "16px" }}
                      >
                        Support Contact Information
                      </Typography>
                    }
                  />
                  <CardContent sx={{ p: 2.5 }}>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 2,
                        mb: 2,
                        borderRadius: 2,
                        background:
                          "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)",
                        border: "1px solid #3b82f6",
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar
                          sx={{ bgcolor: "#3b82f6", width: 40, height: 40 }}
                        >
                          <Headset />
                        </Avatar>
                        <Box sx={{ flex: 1 }}>
                          <Typography
                            variant="subtitle2"
                            sx={{ fontWeight: 700, color: "#1e40af", mb: 0.5 }}
                          >
                            24/7 Call Centre (Help Desk)
                          </Typography>
                          <Stack direction="row" spacing={1} flexWrap="wrap">
                            {formatContact(contactInfo.level1?.contact).map(
                              (contactObj, idx) => (
                                <Chip
                                  key={idx}
                                  icon={
                                    contactObj.type === "email" ? (
                                      <Email sx={{ fontSize: 16 }} />
                                    ) : (
                                      <Phone sx={{ fontSize: 16 }} />
                                    )
                                  }
                                  label={contactObj.value}
                                  color={
                                    contactObj.type === "email"
                                      ? "info"
                                      : "primary"
                                  }
                                  size="small"
                                  sx={{ fontSize: "0.75rem", height: 24 }}
                                />
                              )
                            )}
                          </Stack>
                        </Box>
                      </Stack>
                    </Paper>
                    <Box sx={{ position: "relative", pl: 2 }}>
                      <Box
                        sx={{
                          position: "absolute",
                          top: 20,
                          left: 30,
                          bottom: 0,
                          width: 2,
                          bgcolor: "#e2e8f0",
                          zIndex: 0,
                        }}
                      />

                      {getEscalationSteps().map((level, idx) => (
                        <Box
                          key={level.level}
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            position: "relative",
                            mb: 2,
                          }}
                        >
                          <Avatar
                            sx={{
                              bgcolor:
                                level.level === currentLevel
                                  ? "#059669"
                                  : "#94a3b8",
                              color: "white",
                              width: 32,
                              height: 32,
                              fontSize: 14,
                              fontWeight: 700,
                              zIndex: 1,
                            }}
                          >
                            {level.level}
                          </Avatar>
                          <Paper
                            elevation={level.level === currentLevel ? 3 : 1}
                            sx={{
                              p: 2,
                              ml: 2,
                              flex: 1,
                              borderRadius: 2,
                              background:
                                level.level === currentLevel
                                  ? "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)"
                                  : "#f8fafc",
                              border:
                                level.level === currentLevel
                                  ? "1px solid #059669"
                                  : "1px solid #e2e8f0",
                            }}
                          >
                            <Stack
                              direction="row"
                              spacing={1}
                              alignItems="center"
                              sx={{ mb: 1 }}
                            >
                              <Typography
                                variant="subtitle2"
                                sx={{ fontWeight: 700, fontSize: "0.9rem" }}
                              >
                                {level.title}
                              </Typography>
                              {level.level === currentLevel && (
                                <Chip
                                  label="Current"
                                  color="success"
                                  size="small"
                                  sx={{ fontSize: "0.7rem", height: 20 }}
                                />
                              )}
                              <Chip
                                label={`Level ${level.level}`}
                                color="default"
                                size="small"
                                sx={{ fontSize: "0.7rem", height: 20 }}
                              />
                            </Stack>
                            <Stack direction="row" spacing={1} flexWrap="wrap">
                              {formatContact(level.contact).map(
                                (contactObj, idx) => (
                                  <Chip
                                    key={idx}
                                    icon={
                                      contactObj.type === "email" ? (
                                        <Email sx={{ fontSize: 14 }} />
                                      ) : (
                                        <Phone sx={{ fontSize: 14 }} />
                                      )
                                    }
                                    label={contactObj.value}
                                    color={
                                      contactObj.type === "email"
                                        ? "info"
                                        : "primary"
                                    }
                                    size="small"
                                    sx={{ fontSize: "0.75rem", height: 24 }}
                                  />
                                )
                              )}
                            </Stack>
                            {showFeedbackForm && level.level === currentLevel && [2, 3, 4, 5].includes(level.level) && (
                              <Box
                                sx={{
                                  mt: 2, 
                                  display: 'flex',
                                  alignItems: { xs: 'flex-start', md: 'center' },
                                  gap: 1,
                                  position: 'relative',
                                  '@keyframes fadeIn': {
                                    from: { opacity: 0, transform: 'translateY(20px)' },
                                    to: { opacity: 1, transform: 'none' }
                                  },
                                  animation: 'fadeIn 0.6s'
                                }}
                              >
                               
                                <Box
                                  sx={{
                                    flex: 1,
                                    p: { xs: 1.5, md: 2 }, 
                                    background: 'rgba(255,255,255,0.7)',
                                    borderRadius: 3, 
                                    boxShadow: '0 4px 16px 0 rgba(31,38,135,0.10)', 
                                    backdropFilter: 'blur(6px)', 
                                    border: '1px solid rgba(6,182,212,0.15)', 
                                    minWidth: 0
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    sx={{
                                      fontWeight: 700, 
                                      color: '#0e7490',
                                      mb: 0.5, 
                                      letterSpacing: 0.3, 
                                      fontSize: "16px"
                                    }}
                                  >
                                    Share your feedback
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{ color: '#64748b', mb: 1, fontWeight: 500 }} 
                                  >
                                    Please let us know how we can help you
                                  </Typography>
                                  <form onSubmit={handleFeedbackSubmit}>
                                    <Grid container spacing={1.5}> 
                                      <Grid item xs={12} md={6}>
                                        <TextField
                                          label="Consumer No"
                                          value={consumerNo}
                                          onChange={e => setConsumerNo(e.target.value)}
                                          fullWidth
                                          required
                                          variant="outlined"
                                          size="small" 
                                          sx={{
                                            bgcolor: 'rgba(255,255,255,0.92)',
                                            borderRadius: 2,
                                            boxShadow: '0 1px 2px rgba(6,182,212,0.03)', 
                                          }}
                                          InputLabelProps={{ style: { fontWeight: 600 } }}
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <TextField
                                          label="Feedback"
                                          value={feedback}
                                          onChange={e => setFeedback(e.target.value)}
                                          fullWidth
                                          required
                                          variant="outlined"
                                          size="small" 
                                          sx={{
                                            bgcolor: 'rgba(255,255,255,0.92)',
                                            borderRadius: 2,
                                            boxShadow: '0 1px 2px rgba(6,182,212,0.03)',
                                          }}
                                          InputLabelProps={{ style: { fontWeight: 600 } }}
                                        />
                                      </Grid>
                                      <Grid item xs={12}>
                                        <Button
                                          type="submit"
                                          variant="contained"
                                          disabled={feedbackLoading}
                                          sx={{
                                            borderRadius: 2, 
                                            px: 3, 
                                            py: 1, 
                                            fontWeight: 700,
                                            fontSize: '13px', 
                                            background: 'linear-gradient(90deg, #06b6d4 0%, #3b82f6 100%)',
                                            boxShadow: '0 1px 4px rgba(6,182,212,0.08)', 
                                            mt: 1,
                                            color: '#fff',
                                            textTransform: 'none',
                                            '&:hover': {
                                              background: 'linear-gradient(90deg, #3b82f6 0%, #06b6d4 100%)'
                                            }
                                          }}
                                        >
                                          {feedbackLoading ? 'Submitting...' : 'Submit Feedback'}
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </form>
                                </Box>
                              </Box>
                            )}
                          </Paper>
                        </Box>
                      ))}
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Paper
                      sx={{
                        p: 2,
                        textAlign: "center",
                        bgcolor: "#ffffff",
                        borderRadius: 2,
                        border: "1px solid #e2e8f0",                                    
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{ fontWeight: 600, mb: 2, color: "#1e293b" }}
                      >
                        Are we able to resolve your issue?
                      </Typography>
                      <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                      >
                        <Button
                          variant="contained"
                          color="success"
                          size="medium"
                          startIcon={<ThumbUp />}
                          onClick={() => handleSatisfactionClick(true)}
                          sx={{
                            px: 3,
                            py: 1,
                            fontSize: "0.9rem",
                            fontWeight: 600,
                            borderRadius: 2,
                            textTransform: "none",
                          }}
                        >
                          Satisfied
                        </Button>
                        {currentLevel < 5 && (
                          <Button
                            variant="contained"
                            color="error"
                            size="medium"
                            startIcon={<ThumbDown />}
                            onClick={() => handleSatisfactionClick(false)}
                            sx={{
                              px: 3,
                              py: 1,
                              fontSize: "0.9rem",
                              fontWeight: 600,
                              borderRadius: 2,
                              textTransform: "none",
                            }}
                            disabled={showFeedbackForm && currentLevel !== 1}
                          >
                            Not Satisfied
                          </Button>
                        )}
                      </Stack>
                      {currentLevel < 5 && (
                        <Typography
                          variant="caption"
                          sx={{ mt: 1, color: "#64748b", display: "block" }}
                        >
                          Click "Escalate" to reach the next level of support
                        </Typography>
                      )}
                    </Paper>
                  </CardContent>
                </Card>
              )}

              {/* Instructions */}
              {!selectedArea && (
                <Card
                  sx={{
                    mt: 2,
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    border: "1px solid #e2e8f0",
                  }}
                >
                  <CardContent sx={{ p: 3, textAlign: "center" }}>
                    <Support sx={{ fontSize: 48, color: "#3b82f6", mb: 2 }} />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 600, color: "#1e293b", mb: 2 }}
                    >
                      How to Get Support
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={3}>
                        <Paper
                          sx={{
                            p: 2,
                            bgcolor: "#3b82f6",
                            color: "#fff",
                            borderRadius: 2,
                            height: "100%",
                            width: "259px",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
                          >
                            Step 1
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "0.85rem" }}
                          >
                            Select your locality area
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Paper
                          sx={{
                            p: 2,
                            bgcolor: "#059669",
                            color: "#fff",
                            borderRadius: 2,
                            height: "100%",
                            width: "259px",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
                          >
                            Step 2
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "0.85rem" }}
                          >
                            Zone & Division auto-selected
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Paper
                          sx={{
                            p: 2,
                            bgcolor: "#dc2626",
                            color: "#fff",
                            borderRadius: 2,
                            height: "100%",
                            width: "259px",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
                          >
                            Step 3
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "0.85rem" }}
                          >
                            Contact support team
                          </Typography>
                        </Paper>
                      </Grid>
                      <Grid item xs={12} sm={6} md={3}>
                        <Paper
                          sx={{
                            p: 2,
                            bgcolor: "#7c3aed",
                            color: "#fff",
                            borderRadius: 2,
                            height: "100%",
                            width: "259px",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mb: 1, fontSize: "1rem" }}
                          >
                            Step 4
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "0.85rem" }}
                          >
                            Escalate if needed
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              )}
            </Container>
          </Box>
        {/* </div> */}
      {/* </section> */}
      <Snackbar open={feedbackSuccess} autoHideDuration={4000} onClose={() => setFeedbackSuccess(false)}>
        <Alert onClose={() => setFeedbackSuccess(false)} severity="success" sx={{ width: '100%' }}>
          Feedback submitted successfully!
        </Alert>
      </Snackbar>
      <Snackbar open={!!feedbackError} autoHideDuration={4000} onClose={() => setFeedbackError("")}>
        <Alert onClose={() => setFeedbackError("")} severity="error" sx={{ width: '100%' }}>
          {feedbackError}
        </Alert>
      </Snackbar>
    {/* </div> */}
    </>
  );
}
